import {defaultTo, pipe, trim} from 'ramda';

export const getTrimmedFormValue = pipe(defaultTo<string | undefined>(''), trim);
